import type { Snapshot } from "../shared/domain";
type PdfResult = Awaited<
  ReturnType<typeof import("../shared/invoice-pdf").invoicePdf>
>;
let worker: Worker | undefined;
let sequence = 0;
const jobs = new Map<
  number,
  { resolve: (result: PdfResult) => void; reject: (error: Error) => void }
>();
export function makePdf(snapshot: Snapshot, draft = false): Promise<PdfResult> {
  // Font shaping and PDF layout run off the UI thread, only on this device.
  if (!worker) {
    worker = new Worker(new URL("./pdf-worker.ts", import.meta.url), {
      type: "module",
    });
    worker.onmessage = (
      event: MessageEvent<{ id: number; result: PdfResult; error?: string }>,
    ) => {
      const job = jobs.get(event.data.id);
      if (!job) return;
      jobs.delete(event.data.id);
      event.data.error
        ? job.reject(new Error(event.data.error))
        : job.resolve(event.data.result);
    };
    worker.onerror = () => {
      for (const job of jobs.values())
        job.reject(new Error("PDF preparation was interrupted. Please retry."));
      jobs.clear();
      worker?.terminate();
      worker = undefined;
    };
  }
  const id = ++sequence;
  return new Promise((resolve, reject) => {
    jobs.set(id, { resolve, reject });
    worker!.postMessage({ id, snapshot, draft });
  });
}
export function pdfFile(bytes: Uint8Array, name: string) {
  return new File([new Uint8Array(bytes)], name, { type: "application/pdf" });
}
export function downloadPdf(file: File) {
  const u = URL.createObjectURL(file),
    a = document.createElement("a");
  a.href = u;
  a.download = file.name;
  a.click();
  setTimeout(() => URL.revokeObjectURL(u), 30000);
}
